import { Helmet } from "react-helmet-async";
import Sidebar from "./sidebar";
import { useState, useEffect } from "react";
import api from "../api";
import paystack from "../../feature/paystack.jpg";

function PaymentMethod() {
    const token = localStorage.getItem("access_token");

    // Only needed state
    const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [showPaystackModal, setShowPaystackModal] = useState(false);


    useEffect(() => {
        fetchVendorPaymentMode();
    }, []);

    const fetchVendorPaymentMode = async () => {
        try {
            const response = await api.get("/vendor/", {
                headers: { Authorization: `Bearer ${token}` },
            });

            setSelectedPaymentMode(response.data.pay_mode);
        } catch {}
    };

    const handleRadioChange = async (event) => {
        const newPaymentMode = event.target.value;
        setSelectedPaymentMode(newPaymentMode);

        try {
            await api.patch(
                "/vendor/",
                { pay_mode: newPaymentMode },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setErrorMsg("");
            setSuccessMsg("Payment method updated successfully!");
        } catch {
            setSuccessMsg("");
            setErrorMsg("Failed to update payment method. Please try again.");
        }
    };

    // Auto-clear UI messages after 5 seconds
    useEffect(() => {
        if (!successMsg && !errorMsg) return;

        const timer = setTimeout(() => {
            setSuccessMsg("");
            setErrorMsg("");
        }, 5000);

        return () => clearTimeout(timer);
    }, [successMsg, errorMsg]);

    return (
        <>
            <Helmet>
                <title>Payment Method</title>
                <meta name="description" content="Payment Method" />
            </Helmet>

            <section className="container mtopcon dashb">
                <div className="row">
                    <div className="col-12 col-lg-2 dash-min mb-3">
                        <div className="nav-left-sidebar sidebar-dark pc">
                            <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                <div className="collapse navbar-collapse" id="navbarNav">
                                    <Sidebar />
                                </div>
                            </nav>
                        </div>
                    </div>

                    <div className="col-12 col-lg-10 dash-max">
                        <div className="row mb-4 ph-header-con">
                            <h6 className="pageheader-title mb-0">Payment Method</h6>
                            <p className="grey-text lh0 font8">
                                Choose how you want to receive payments from your customers.
                            </p>
                        </div>

                        <div className="row d-flex justify-content-center mt-4">
                            <div className="col-12 col-lg-4">
                                {/* Selected Payment Banner */}
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <div className="p-3 br-18 bg-light border">
                                            <span className="font9 text-muted">Active Payment Method</span>
                                            <h6 className="mb-0 fw-bold mt-1">
                                                {selectedPaymentMode === "0" ? "Manual Payment" : "Automated Payment"}
                                            </h6>
                                        </div>
                                    </div>
                                </div>

                                {/* Notification Messages */}
                                {(successMsg || errorMsg) && (
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <div className={`alert ${successMsg ? "alert-success" : "alert-danger"} py-2`}>
                                                <b>{successMsg || errorMsg}</b>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Payment Options */}
                                <div className="row">
                                    <div className="col-12">

                                        {/* Manual Payment Card */}
                                        <div
                                            className={`card p-4 shadow-sm mb-3 pointer border ${
                                                selectedPaymentMode === "0"
                                                    ? "border-primary"
                                                    : "border-light"
                                            }`}
                                            onClick={() => handleRadioChange({ target: { value: "0" } })}
                                        >
                                            <div className="d-flex justify-content-between align-items-start">
                                                <div>
                                                    <h5 className="fw-bold">Manual Payment</h5>
                                                    <p className="text-muted font9 mb-2">
                                                        Customers pay manually via SIM Toolkit or banking app.
                                                        You confirm then mark the order as paid.
                                                    </p>
                                                </div>

                                                <input
                                                    type="radio"
                                                    value="0"
                                                    checked={selectedPaymentMode === "0"}
                                                    onChange={handleRadioChange}
                                                    className="form-check-input mt-1 border-2px" 
                                                />
                                            </div>
                                            <div className="text-success fw-bold font9 mt-2">0% Fees</div>
                                        </div>

                                        {/* Automated Payment Card */}
                                        <div
                                            className={`card p-4 shadow-sm pointer border ${
                                                selectedPaymentMode === "1"
                                                    ? "border-primary"
                                                    : "border-light"
                                            }`}
                                            //onClick={() => handleRadioChange({ target: { value: "1" } })}
                                        >
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <h5 className="fw-bold">Automated Payment</h5>
                                                    <p className="text-muted font9 mb-2">
                                                        Customers are instantly prompted-to-pay.
                                                        Orders & stock update automatically.
                                                        Funds settle in your bank or M-Pesa within 48 hours.
                                                    </p>
                                                </div>

                                                <input
                                                    type="radio"
                                                    value="1"
                                                    checked={selectedPaymentMode === "1"}
                                                    onChange={handleRadioChange}
                                                    className="form-check-input mt-1 border-2px" 
                                                />
                                            </div>

                                            <div className="text-success fw-bold font9 mt-2">
                                                From 2% Per Transaction (via Paystack)
                                            </div>

                                            {/* Extra Paystack Advantage Section */}
                                            <div
                                                className="mt-3 p-2 bg-light rounded small text-muted pointer"
                                                onClick={() => setShowPaystackModal(true)}
                                            >
                                                <b>Powered by Paystack</b> – Click to learn more.
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Paystack Information Modal */}
                <div
                    className={`modal fade ${showPaystackModal ? "show d-block" : ""}`}
                    tabIndex="-1"
                    role="dialog"
                    style={{ background: "rgba(0,0,0,0.5)" }}
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content shadow-lg">

                            <div className="modal-header border-0">
                                <h5 className="modal-title fw-bold">
                                    <img
                                        loading="lazy" src={paystack}
                                        alt="Paystack"
                                        style={{ height: "70px", marginRight: "6px" }}
                                    />
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowPaystackModal(false)}
                                ></button>
                            </div>

                            <div className="modal-body p-4 pt-0">

                                <p className="text-muted font9">
                                    Paystack helps African businesses accept secure payments across
                                    M-Pesa, Card, Bank, USSD, and Mobile Money channels.
                                </p>

                                <div className="p-3 border br-18 mb-3">
                                    <ul className="small text-muted m-0 p-0">
                                        <li>Instant customer checkout & payment prompts</li>
                                        <li>Supports M-Pesa, M-Pesa STK Push, Airtel Money & Cards</li>
                                        <li>Secure & PCI-DSS compliant</li>
                                        <li>Fast payouts to your bank or M-Pesa</li>
                                        <li>Real-time confirmation for orders</li>
                                    </ul>
                                </div>

                                <div className="p-3 border br-18">
                                    <h6 className="fw-bold">Transaction Fees</h6>
                                    <p className="small mb-1">M-Pesa: <b>2%</b></p>
                                    <p className="small mb-1">Local Cards: <b>3%</b></p>
                                    <p className="small mb-1">International Cards: <b>4%</b></p>
                                    <p className="small text-muted mt-2">
                                        You can switch back to manual payment any time.
                                    </p>
                                </div>

                            </div>

                            <div className="modal-footer border-0 p-4 pt-0">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowPaystackModal(false)}
                                >
                                    Close
                                </button>
                            </div>

                        </div>
                    </div>
                </div>


            </section>
        </>
    );
}

export default PaymentMethod;
